import dayjs from "dayjs"

import { GlTransactionRowType } from "@/graphql/codegen/graphql"
import { formatNumber } from "@/utils/number"

const ACCOUNTS_PAYABLE_BALANCE_AS_OF_DATE_FORMAT = "MMM DD, YYYY"

export interface AccountsPayableBalanceSummary {
  amountLabel: string
  asOfLabel: string
  isDueFromVendor: boolean
}

export const toSignedAccountsPayableAmount = (amount: number, type: GlTransactionRowType): number =>
  type === GlTransactionRowType.Debit ? -amount : amount

export const formatAccountsPayableAmount = (amount: number): string => {
  const sign = amount < 0 ? "-" : ""
  return `${sign}$${formatNumber(Math.abs(amount), 2, 2)}`
}

export const formatAccountsPayableBalance = (balance: number): string => formatAccountsPayableAmount(balance)

const getAccountsPayableBalanceLabel = (balance: number, isDueFromVendor: boolean): string => {
  if (balance === 0) return "Balance"
  if (isDueFromVendor) return "Due From Vendor"
  return "Balance Due to Vendor"
}

export const toAccountsPayableBalanceSummary = (
  balance: number,
  asOfDate: string = dayjs().toISOString()
): AccountsPayableBalanceSummary => {
  const isDueFromVendor = balance < 0
  const label = getAccountsPayableBalanceLabel(balance, isDueFromVendor)

  return {
    amountLabel: `$${formatNumber(Math.abs(balance), 2, 2)} ${label}`,
    asOfLabel: dayjs(asOfDate).format(ACCOUNTS_PAYABLE_BALANCE_AS_OF_DATE_FORMAT),
    isDueFromVendor,
  }
}
